import React from 'react';
import { oneOf } from 'prop-types';
//* MUI
import { Badge, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
//* Styles
import './CustomIconButton.scss';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white
  }
}));

type CustomIconButtonProps = {
  size?: string;
  color?: string;
  tooltip?: string;
  icon: JSX.Element;
  disabled?: boolean;
  iconColor?: string;
  additionalClassName?: string;
  badgeContent?: number | string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const CustomIconButton = ({
  icon,
  size,
  color,
  tooltip,
  onClick,
  disabled,
  iconColor,
  badgeContent = 0,
  additionalClassName
}: CustomIconButtonProps) => {
  return (
    <LightTooltip title={tooltip}>
      <Badge className="custom-icon-button__badge" badgeContent={badgeContent}>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          className={`custom-icon-button custom-icon-button--${color} custom-icon-button--text custom-icon-button--text-${iconColor} custom-icon-button--${size} ${
            additionalClassName ? additionalClassName : ''
          }`}
        >
          {icon}
        </IconButton>
      </Badge>
    </LightTooltip>
  );
};

CustomIconButton.propTypes = {
  color: oneOf(['gold', 'white', 'transparent'])
};

CustomIconButton.defaultProps = {
  color: 'white'
};

export default CustomIconButton;
